module.exports = __webpack_public_path__ + "static/images/r-rakutenlogo.79b49a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/r-rakutenlogo.png
// module id = Bs+F
// module chunks = 1